var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4358_30877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 7.5H12.5551C12.2745 6.41325 11.6947 5.42699 10.8816 4.6533C10.0685 3.8796 9.05462 3.34949 7.95527 3.12321C6.85593 2.89692 5.71515 2.98353 4.66257 3.37319C3.60999 3.76286 2.68781 4.43995 2.00082 5.32754C1.31383 6.21512 0.889575 7.27761 0.776263 8.39427C0.662951 9.51092 0.865126 10.637 1.35981 11.6445C1.8545 12.652 2.62187 13.5005 3.57472 14.0937C4.52757 14.6868 5.62769 15.0008 6.75008 15H13.5001C14.4946 15 15.4485 14.6049 16.1517 13.9017C16.855 13.1984 17.2501 12.2446 17.2501 11.25C17.2501 10.2554 16.855 9.30161 16.1517 8.59835C15.4485 7.89509 14.4946 7.5 13.5001 7.5Z",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4358_30877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.5573ff5c7d2a83df8565650f5bcc3718.svg";
export { ForwardRef as ReactComponent };